import { Component, Inject, TemplateRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'tekman-ui-modal',
  templateUrl: './modal.component.html',
})
export class UiModalComponent<T> {
  constructor(
    public dialogRef: MatDialogRef<UiModalComponent<T>>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      headerText: string;
      template: TemplateRef<any>;
      context: T;
    }
  ) {}
}
